import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/avatars/Alicja.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/avatars/Justyna.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/avatars/Krzysztof.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["DevelopmentSection"] */ "/app/src/app/work/_components/development-section/development-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/work/_components/hero-section/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SecuritySection"] */ "/app/src/app/work/_components/security-section/security-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TechstackSection"] */ "/app/src/app/work/_components/techstack-section/techstack-section.tsx");
